// src/App.js
import React from "react";
import { HashRouter as Router, Routes, Route, Link } from "react-router-dom";

import Forecast from "./pages/Forecast";
import MEK from "./pages/MEK";
import Articles from "./pages/Articles";
import MapPage from "./pages/Map"; // your Map.js default export
import BerkeleyGuide from "./pages/BerkeleyGuide";
import BikeHighlights from "./pages/BikeHighlights";
import FailureOfPlanning from "./pages/FailureOfPlanning";
import PostPage from "./pages/PostPage";



import "./App.css";
import CalendarWidget from "./components/CalendarWidget";

const EVENTS = {
  "2026-04-25": [{ title: "TDS Enduro Race", color: "rgba(16,185,129,0.9)" }],
};

function App() {
  return (
    <Router>
      <div>
        {/* Top Section with Title and Links */}
        <div className="top-section">
          <Link to="/" className="site-title">QuailsTrails</Link>
          <div className="nav-links-slim">
            <Link to="/Calendar">Calendar</Link>
            <Link to="/Highlights">Highlights</Link>
            <Link to="/About">About</Link>
            <Link to="/Articles">Articles</Link>
          </div>
        </div>

        <Routes>
          <Route
            path="/"
            element={
              <div className="main-page">
                <div className="main-content">
                  <CalendarWidget
                      initialYear={2025}
                      initialMonthIndex={11} // December
                      eventsByDate={EVENTS}
                    />
                </div>
             
              </div>
              
            }
          />
          <Route path="/Forecast" element={<Forecast />} />
          <Route path="/Highlights" element={<BikeHighlights />} />
          <Route path="/MEK" element={<MEK />} />
          <Route path="/Articles" element={<Articles />} />
          <Route path="/Map" element={<MapPage />} />
          <Route path="/berkeley-guide" element={<BerkeleyGuide />} />
          <Route path="/failure-of-planning" element={<FailureOfPlanning />} />
          <Route path="/post/:slug" element={<PostPage />} />


        </Routes>
      </div>
    </Router>
  );
}

export default App;

